export const SUB_STATUS_CLS = {
  pending_approval: "bg-slate-500 text-white",
  trial: "bg-sky-600 text-white",
  active: "bg-[hsl(var(--success))] text-white",
  expired: "bg-destructive text-white",
  suspended: "bg-red-900 text-white",
  exempt: "bg-violet-700 text-white",
  migration_pending: "bg-amber-500 text-black",
};
export const SUB_STATUS_TR = {
  pending_approval: "Onay bekliyor", trial: "Ücretsiz deneme", active: "Aktif abonelik", expired: "Süresi dolmuş",
  suspended: "Askıya alınmış", exempt: "Süresiz ücretsiz / muaf", migration_pending: "Geçiş bekliyor",
};
export const PAY_STATUS = {
  pending: ["Onay bekliyor", "bg-amber-500 text-white"], approved: ["Onaylandı", "bg-[hsl(var(--success))] text-white"],
  rejected: ["Reddedildi", "bg-destructive text-white"], cancelled: ["İptal edildi", "bg-slate-500 text-white"],
};
export const AUDIT_TR = {
  trial_started: "Deneme başladı", trial_denied: "Deneme verilmedi (incelemeye alındı)", extend_trial: "Deneme uzatıldı",
  set_trial_end: "Deneme bitişi ayarlandı", grant_paid: "Ücretli süre tanımlandı", set_paid_until: "Ücretli bitiş tarihi değiştirildi", set_exempt: "Süresiz muafiyet verildi",
  unset_exempt: "Muafiyet kaldırıldı", suspend: "Askıya alındı", unsuspend: "Askı kaldırıldı", start_trial: "Deneme başlatıldı (manuel)",
  end_migration_expire: "Geçiş sonlandırıldı", trial_exception_granted: "Deneme istisnası verildi", trial_denial_confirmed: "Deneme reddi onaylandı",
  trial_days_changed: "Varsayılan deneme süresi değişti", package_created: "Paket oluşturuldu", package_updated: "Paket güncellendi",
  payment_reported: "Ödeme bildirildi", payment_cancelled: "Ödeme bildirimi iptal edildi", payment_rejected: "Ödeme reddedildi",
};
export const fmtD = (iso) => (iso ? new Date(iso).toLocaleDateString("tr-TR") : "—");
export const fmtDT = (iso) => (iso ? new Date(iso).toLocaleString("tr-TR") : "—");
export const tl = (n) => (n == null ? "—" : `${Number(n).toLocaleString("tr-TR", { minimumFractionDigits: 2 })} ₺`);
